export function normalizeHandle(input: string, service = 'https://bsky.social'): string {
  let h = input.trim().replace(/^@+/, '').toLowerCase()
  if (!h) return ''
  if (h.startsWith('did:')) return h
  if (!h.includes('.')) {
    let host = 'bsky.social'
    try {
      host = new URL(service).host
    } catch {
      /* keep default */
    }
    h = `${h}.${host}`
  }
  return h
}

export function blobUrl(
  did: string,
  cid: string,
  kind: 'avatar' | 'banner' | 'feed_thumbnail' | 'feed_fullsize' = 'avatar',
): string {
  // The bsky CDN does NOT accept the @jpeg suffix for feed_thumbnail/fullsize;
  // it returns 404. AppView's view embed yields the URL without any suffix.
  return `https://cdn.bsky.app/img/${kind}/plain/${did}/${cid}`
}

export function videoThumbUrl(did: string, cid: string): string {
  return `https://video.bsky.app/watch/${did}/${cid}/thumbnail.jpg`
}

export function videoPlaylistUrl(did: string, cid: string): string {
  return `https://video.bsky.app/watch/${did}/${cid}/playlist.m3u8`
}

export function bskyPostUrl(did: string, rkey: string): string {
  return `https://bsky.app/profile/${did}/post/${rkey}`
}
